import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('shared.data.queries.requests.useSetCustomerDecisionInQuote', {
    acceptedRequest: 'The request has been accepted',
    declinedRequest: 'The request has been declined',
    unavailableQuoteError: `The customer's decision cannot be determined as it appears to have either expired or been deleted within Xero`,
});
